import { cloneDeep } from 'lodash';

// mutations
export default {
  /**
   * [admin側] ピックアップ広告一覧をセットする
   */
  updateAdminPickupAds(state, pickupAds) {
    console.log('updateAdminPickupAds');
    state.adminPickupAds = pickupAds;
  },

  /**
   * [病院側] ピックアップ広告一覧をセットする
   */
  updateClinicPickupAds(state, pickupAds) {
    console.log('updateClinicPickupAds');
    state.clinicPickupAds = pickupAds;
  },
};
